import React from "react"
import { CommonDisclaimerText } from "config/disclaimerText"

export const Disclaimer = () => {
  return (
    <div className="contents-disclaimer">
      <div className="panel panel-disclaimer">
        <div className="disclaimer-box">
          {/*一旦コメントアウト*/}
          <div className="disclaimer-text-box">{CommonDisclaimerText}</div>
          <ul className="disclaimer-list">
            <li
              onClick={() => {
                window.open("http://www.aizawa.co.jp/documents/guide/risk.pdf")
              }}
            >
              <span className="important-notes">
                重要事項説明書（リスク説明）
              </span>
            </li>
            <li
              onClick={() => {
                window.open(
                  "http://www.aizawa.co.jp/documents/guide/unfair.pdf"
                )
              }}
            >
              <span className="unfair-trade">不公正取引について</span>
            </li>
            <li
              onClick={() => {
                window.open("http://www.aizawa.co.jp/documents/guide/execu.pdf")
              }}
            >
              <span className="best-execution-policy">最良執行方針</span>
            </li>
            <li
              onClick={() => {
                window.open(
                  "http://www.aizawa.co.jp/documents/guide/sitepolicy.pdf"
                )
              }}
            >
              <span className="site-policy">サイトポリシー（免責事項等）</span>
            </li>
            <li
              onClick={() => {
                window.open(
                  "http://www.aizawa.co.jp/documents/guide/privacy.pdf"
                )
              }}
            >
              <span className="site-policy">プライバシーポリシー</span>
            </li>
            <li
              onClick={() => {
                window.open("http://www.aizawa.co.jp/documents/guide/invi.pdf")
              }}
            >
              <span className="site-policy">勧誘方針</span>
            </li>
            <li
              onClick={() => {
                window.open("mailto:question-btc@aizawa.co.jp")
              }}
            >
              <span className="site-policy">お問い合わせ</span>
            </li>
          </ul>
          <div className="disclaimer-footer">
            <div className="copyright-txt">
              <span>
                © 2020 AIZAWA SECURITIES CO.,LTD. /TRAdE WORKS Co., Ltd.
              </span>
            </div>
            <div
              className="link-copyright-txt"
              onClick={() => {
                window.open(
                  "http://www.aizawa.co.jp/documents/guide/sitepolicy.pdf"
                )
              }}
            >
              <span>
                <i className="material-icons">open_in_new</i>
                著作権について
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
